import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FaArrowLeft, FaEnvelope, FaLock, FaUserShield } from "react-icons/fa";

import { AuthApiError, loginAdmin } from "../../services/authApi";
import { ADMIN_AUTH_FLAG_KEY, hasAdminSession, setAdminJwt } from "../../services/authToken";
import "../../Components/admin/adminLogin.css";

export default function AdminLogin() {
  const navigate = useNavigate();
  useEffect(() => {
    if (hasAdminSession()) navigate("/admin", { replace: true });
  }, [navigate]);

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [formError, setFormError] = useState("");

  const onSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setFormError("");

    try {
      const result = await loginAdmin(email, password);
      if (result.mock) {
        localStorage.setItem(ADMIN_AUTH_FLAG_KEY, "true");
        const devJwt = process.env.REACT_APP_ADMIN_JWT;
        if (devJwt) setAdminJwt(devJwt);
        else setAdminJwt(null);
      } else {
        localStorage.setItem(ADMIN_AUTH_FLAG_KEY, "true");
      }
      navigate("/admin", { replace: true });
    } catch (err) {
      const msg = err instanceof AuthApiError ? err.message : err?.message || "Sign in failed";
      setFormError(msg);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="adminLoginPage">
      <div className="adminLoginCard" role="dialog" aria-label="Admin sign in">
        <div className="adminLoginTop">
          <Link className="adminLoginBackHome" to="/">
            <span className="adminLoginBackHomeIcon" aria-hidden="true">
              <FaArrowLeft />
            </span>
            Back to home
          </Link>
          <div className="adminLoginIcon" aria-hidden="true">
            <FaUserShield />
          </div>
          <h1 className="adminLoginTitle">Sign in</h1>
          <p className="adminLoginSubtitle">Enter your email and password to access your account</p>
        </div>

        <form className="adminLoginForm" onSubmit={onSubmit}>
          {formError ? (
            <div className="adminLoginFormError" role="alert">
              {formError}
            </div>
          ) : null}
          <label className="adminLoginLabel" htmlFor="adminEmail">
            Email
          </label>
          <div className="adminLoginField">
            <span className="adminLoginFieldIcon" aria-hidden="true">
              <FaEnvelope />
            </span>
            <input
              id="adminEmail"
              className="adminLoginInput"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              type="email"
              autoComplete="email"
              required
            />
          </div>

          <label className="adminLoginLabel" htmlFor="adminPassword" style={{ marginTop: 10 }}>
            Password
          </label>
          <div className="adminLoginField">
            <span className="adminLoginFieldIcon" aria-hidden="true">
              <FaLock />
            </span>
            <input
              id="adminPassword"
              className="adminLoginInput"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter your password"
              type="password"
              autoComplete="current-password"
              required
            />
          </div>

          <button className="adminLoginButton" type="submit" disabled={submitting}>
            {submitting ? "Signing in..." : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}

